module.exports = __webpack_public_path__ + "img/img1.a8ca7b02.png";